/*
 * @Author: 范向玲
 * @Date: 2023-05-30 10:37:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-14 10:12:28
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\tradeQuantity\manage\tableConfig.js
 */
import config from '@/config/config';

const screenOperationConf = [1];

const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'commodity',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '贸易品',
    dataIndex: 'tradeCodeGoods',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '频率',
    dataIndex: 'frequency',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '重量',
    dataIndex: 'categories',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '金额',
    dataIndex: 'unit',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '数据来源',
  //   dataIndex: 'primaryIntervalCommodity',
  //   ellipsis: true,
  //   align: 'center',
  //   width: 100,
  // },
  {
    title: '开始时间',
    dataIndex: 'minYear',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '结束时间',
    dataIndex: 'maxYear',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '描述',
  //   dataIndex: 'description',
  //   ellipsis: true,
  //   align: 'center',
  // },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 240,
  },
];

const tableData1 = [
  {
    id: '1',
    propName: '金矿',
  },
  {
    id: '2',
    propName: '金矿',
  },
];
const downloadInfoConf = [
  [
    {
      name: '日期排序',
      type: 'radio',
      children: [
        { key: 'desc', name: '日期降序' },
        { key: 'asc', name: '日期升序' },
      ],
      selectValue: '',
      valueType: 'str',
    },
  ],
  // [
  //   {
  //     name: '包含指标',
  //     type: 'checkbox',
  //     children: [
  //       { key: '单位', name: '单位', },
  //       { key: '数据来源', name: '数据来源', },
  //       { key: '频率', name: '频率', },
  //       { key: '时间区间', name: '时间区间', },
  //       { key: '结束时间', name: '结束时间', },
  //       { key: '更新时间', name: '更新时间', },
  //       { key: '指标描述', name: '指标描述', },
  //     ],
  //     selectValue: [],
  //     valueType: 'arr',
  //   },
  // ],
  // [
  //   {
  //     name: 'excel作图',
  //     type: 'checkbox',
  //     children: [
  //       { key: '显示图形', name: '显示图形', },
  //     ],
  //     selectValue: [],
  //     valueType: 'arr',
  //   },
  //   {
  //     name: '图形样式',
  //     type: 'radio',
  //     children: [
  //       { key: '折线', name: '折线', },
  //       { key: '柱状', name: '柱状', },
  //     ],
  //     selectValue: '',
  //     valueType: 'str',
  //   },
  // ],
];

export { tableConfig, tableData1, downloadInfoConf };
